export function parseMediaUrl(url: string) {
  try {
    const { host, pathname, search } = new URL(url);

    const normalizedHost = host.replace(/^www\./, '');
    const searchParams = new URLSearchParams(search);

    let matches;

    switch (normalizedHost) {
      case 'youtube.com':
        if (pathname.startsWith('/embed')) {
          return ['youtube', pathname.substr(1)];
        }

        if (searchParams.has('v')) {
          return ['youtube', searchParams.get('v')];
        }

        return ['youtube', null];
      case 'youtu.be':
        return ['youtube', pathname.substr(1)];
      case 'vimeo.com':
      case 'player.vimeo.com':
        matches = url.match(/(\d+)$/);

        return ['vimeo', matches ? matches[0] : null];
      default:
        return [null, url];
    }
  } catch {
    return [null, null];
  }
}
